import { SNWebCrypto } from '@standardnotes/sncrypto-web';
export const WebCrypto = new SNWebCrypto();
